export default __webpack_public_path__ + "static/media/icon-solution-7.10f6e2a3.svg";